import React, { PropTypes } from 'react'

import Menu from './menu'

const Settings = ({ children }) => (
  <div className="row">
    <div className="col-sm-3"><Menu /></div>
    <div className="col-sm-9">{children}</div>
  </div>
)

Settings.propTypes = {
  children: PropTypes.any,
}

export default Settings



// WEBPACK FOOTER //
// ./src/containers/Settings/index.js